/// <amd-module name="Wit/WorkItemForm/Links/Controls/ArtifactLinkPlaceholder" />
import * as React from "react";

export interface IArtifactLinkPlaceholderProps {
    className?: string;
    showDetails?: boolean;
    showIcon?: boolean;
}

export function ArtifactLinkPlaceholder({ className, showIcon, showDetails }: IArtifactLinkPlaceholderProps) {
    return (
        <div className={`artifact-link-placeholder flex-column margin-bottom-8 ${className}`}>
            <div className="flex-row flex-center margin-bottom-4">
                {showIcon && <div className="shimmer shimmer-circle-small icon-margin" />}
                <div className="link-title-placeholder shimmer shimmer-line" />
            </div>
            {showDetails && (
                <div className="flex-row flex-center margin-bottom-4 margin-left-16">
                    <div className="link-date-placeholder shimmer shimmer-line icon-margin" />
                    <div className="link-state-placeholder shimmer shimmer-line" />
                </div>
            )}
        </div>
    );
}
